import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HeaderService } from '../header.service';
import RoutesserviceService from '../routesservice.service';

@Injectable({
  providedIn: 'root'
})
export class HolidayService {

  constructor(
    private httpClient: HttpClient,
    private Customeroutes: RoutesserviceService,
    private HeaderService: HeaderService
  ) {  }

  async getHolidays(){
   return this.httpClient
    .post(this.Customeroutes.getHolidays(), '', {
      headers: this.HeaderService.getHeaderWithToken(
        localStorage.getItem('token')
      ),
    })
    .pipe()
    .toPromise()
    .then((data: any) => {
      return data
    });
  }

  async addHolidays(name : string, date : string){
    const formData = {
      day_name: name,
      date: date,
    };
    return this.httpClient
     .post(this.Customeroutes.addHoliday(), formData, {
       headers: this.HeaderService.getHeaderWithToken(
         localStorage.getItem('token')
       ),
     })
     .pipe()
     .toPromise()
     .then((data: any) => {
       return data
     });
   }


}
